import { Base } from './Base'

export class Accordion extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element)
    this.init()
  }

  init() {
    this.bindFunctions()
    this.setEventListeners()

    this.setInitAttributes()
  }

  setEventListeners() {
    const { trigger } = this.refs

    trigger.addEventListener('click', this.handleClick)
  }

  bindFunctions() {
    this.handleClick = this.handleClick.bind(this)
  }

  setInitAttributes() {
    const { trigger, content } = this.refs

    content.setAttribute('hidden', true)
  }

  handleClick() {
    const { content } = this.refs

    content.toggleAttribute('hidden')
  }

  cleanup() {}
}
